<template>
    <div class="trainingGuide">
        <div class="box-guide">
            <img :src="item.icon" v-for="(item, index) in titleList" :key="index" @click="goDetail(index, item.text)">
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            titleList: [
                { icon: this.$commonUrl.cos() + '/image/activit/trainguide_zhuce.png', text: '注册指南'},  // 注册
                { icon: this.$commonUrl.cos() + '/image/activit/trainguide_jiedan.png', text: '接单指南'}, // 接单
                { icon: this.$commonUrl.cos() + '/image/activit/trainguide_tixian.png', text: '提现指南'}, // 提现
            ]
        };
    },
    created() {
    },
    mounted() {
    },
    methods: {
        goDetail(type, text) {
            wsdata.track('DJ_OfficeGuideClick', {
                page_title: '培训中心',
                click_content: text
            })
            this.$router.push({
                path: '/home/guideDetail',
                query: {
                    type
                }
            })
        }
    }
};
</script>
<style lang="less" scoped>
.trainingGuide {
    background: #F2F2F2;
    position: relative;
    height: 100vh;
}
.box-guide {
    padding: 12px;
    font-size: 0;
    .guide-item {
        background: #FDFEFF;
        border-radius: 10px;
        padding: 16px;
        margin-bottom: 12px;
        .title {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #333333;
            line-height: 25px;
        }
    }
    img {
        width: 351px;
        height: 110px;
        margin-bottom: 12px;
    }
}

</style>
